module.exports = __webpack_public_path__ + "static/media/BooksAndStudent.1ea1002d.svg";